import { render, staticRenderFns } from "./VaSlider.demo.vue?vue&type=template&id=229999a9&"
import script from "./VaSlider.demo.vue?vue&type=script&lang=js&"
export * from "./VaSlider.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports